import { render } from "./TestsPage.vue?vue&type=template&id=1b9d483c"
import script from "./TestsPage.vue?vue&type=script&lang=js"
export * from "./TestsPage.vue?vue&type=script&lang=js"

import "./TestsPage.vue?vue&type=style&index=0&id=1b9d483c&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__